import { render, staticRenderFns } from "./ConfigureCompanyTemplate.vue?vue&type=template&id=5a55ba04&scoped=true"
import script from "./ConfigureCompanyTemplate.vue?vue&type=script&lang=js"
export * from "./ConfigureCompanyTemplate.vue?vue&type=script&lang=js"
import style0 from "./ConfigureCompanyTemplate.vue?vue&type=style&index=0&id=5a55ba04&prod&lang=scss&scoped=true"
import style1 from "./ConfigureCompanyTemplate.vue?vue&type=style&index=1&id=5a55ba04&prod&lang=scss"
import style2 from "./ConfigureCompanyTemplate.vue?vue&type=style&index=2&id=5a55ba04&prod&scoped=true&lang=css"
import style3 from "./ConfigureCompanyTemplate.vue?vue&type=style&index=3&id=5a55ba04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55ba04",
  null
  
)

export default component.exports